<div
  class="modal fade"
  [id]="modalId()"
  tabindex="-1"
  aria-labelledby="ModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" [class.modal-lg]="largeModal()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalLabel">{{ modalTitle() }}</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          i18n-aria-label="
            accessible label|Accessible label for the button to close the modal@@modalCloseAriaLabel"
        ></button>
      </div>

      <div class="modal-body">
        @if (bodyTpl()) {
          <ng-container [ngTemplateOutlet]="bodyTpl()"></ng-container>
        } @else {
          <div class="pre-line">{{ bodyText() }}</div>
        }
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          i18n="
            button|Secondary button to dismiss the modal without confirming the
            action@@modalCancelButton"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-success"
          (click)="confirmAction()"
          data-bs-dismiss="modal"
          [disabled]="confirmDisabled()"
          i18n="
            button|Button to confirm and proceed with the action in the modal@@modalConfirmButton"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
